// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"793c914378aac7bbca5b","135":"d4904f0efb7bad1c15ff","186":"8e676e83f6d19ff26792","812":"fcdfb536e2e083fe1dd2"}[chunkId] + ".chunk.js";
};